import { useQuery } from '@tanstack/react-query'
import apiClient from 'application/core/data/apiClient'
import { AxiosError } from 'axios'

const fetchPaymentStatus = async (id: number) => {
  try {
    const response = await apiClient.post('/api/payment/check', { open_order_id: id })

    return response.data
  } catch (error) {
    if (error instanceof AxiosError) {
      console.error(error, error.response)
    }

    throw error
  }
}

export const usePaymentStatus = (
  openOrderId: number,
  { enabled }: { enabled: boolean } = { enabled: true },
) => {
  return useQuery(['checkpayment', openOrderId], () => fetchPaymentStatus(openOrderId), {
    enabled,
    refetchInterval: 10000,
  })
}
